import { render, staticRenderFns } from "./ConfirmQuizGroup.vue?vue&type=template&id=7f87cfdb"
import script from "./ConfirmQuizGroup.vue?vue&type=script&lang=js"
export * from "./ConfirmQuizGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports